<template>
    <div class="content">
        <img class="banner-img" style="object-position: top" src="../../../public/img/show/head_img.jpg">

        <h6 class="title_g">FAIR & SHOW<br><p>International exhibitions</p></h6>
        <img class="fair" src="../../../public/img/show/fair.png">
        <div class="title">
            <h1>Canton fair Spring Apr.</h1>
            <h1>Canton fair Autumn Oct.</h1>
            <h1>Frankfurt Ambiente Feb.</h1>
            <h1>Chicago IHA Home & Houseware Mar.</h1>
            <h1>Moscow HouseHoid Expo Mar.</h1>
            <h1>Hong Kong Houseware Fair Apr. 20-23</h1>
        </div>

        <div class="imgs">
            <img src="../../../public/img/show/imgs.jpg">
        </div>
    </div>
</template>

<script>
export default {
    name: 'Exhibition',
}
</script>

<style lang="less" scoped>
    .content { background-color: #f5f4f4; }
    
    .fair { width: 100%; padding: 0 .8rem; box-sizing: border-box; }
    .title { text-align: center; padding: 1rem 0 1.5rem; line-height: 1.5rem; font-size: .9rem; color: #4e4b4a; }
    .imgs { width: calc(100% - 1rem); padding: .5rem; text-align: center; background-color: #bebebe; }
    .imgs img { width: 100%; }
</style>